import * as yup from 'yup'
import {
  REQUIRED_FIELD,
  REQUIRED_DOCUMENT,
  ERROR_DOCUMENT_UPLOADING,
  ERROR_APPLICATION_ACCEPT_DATA_USAGE,
} from './../constants'

export default yup.object({
  contacts: yup.array(
    yup.object({
      firstname: yup.string().required(REQUIRED_FIELD),
      lastname: yup.string().required(REQUIRED_FIELD),
      email: yup
        .string()
        .email()
        .required(REQUIRED_FIELD),
      phone: yup.string().required(REQUIRED_FIELD),
      handOff: yup.boolean(),
      documents: yup
        .array()
        .when(['handOff', '$isBrusselsZip'], {
          is: (handOff, isBrusselsZip) => (handOff === false || handOff === undefined) && !isBrusselsZip,
          then: yup
            .array()
            .min(1, REQUIRED_DOCUMENT)
            .required(REQUIRED_DOCUMENT),
        })
        .test('isPresent', ERROR_DOCUMENT_UPLOADING, val => {
          const uploadingFiles = (val && val.filter(file => file && file.isUploading !== undefined)) || 0
          return !uploadingFiles.length
        }),
    }),
  ),
  acceptDataUsages: yup.boolean().oneOf([true], ERROR_APPLICATION_ACCEPT_DATA_USAGE),
})



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/contractSchema.js